<script setup>
import { AisSearchBox } from "vue-instantsearch/vue3/es";

import CustomSearchIcon from "@/components/svg-icons/CustomSearchIcon.vue";

const MAX_ALLOWED_LENGTH = 512;
</script>
<template>
  <ais-search-box class="flex w-full justify-end flex-row">
    <template v-slot="{ currentRefinement, refine }">
      <div class="flex flex-grow w-[60%] relative font-normal font-montserrat">
        <input
          :value="currentRefinement"
          @input="refine($event.currentTarget.value)"
          type="text"
          placeholder="SEARCH"
          class="font-montserrat font-bold text-base text-university-primary leading-5 py-1 pl-[3.25rem] pr-[1rem] border border-gray-475 rounded-full h-10 w-full placeholder-university-primary placeholder-opacity-50"
          autocomplete="off"
          :maxlength="MAX_ALLOWED_LENGTH"
        />
        <CustomSearchIcon size="20" stroke="#007f80" class="self-center absolute left-[1rem]" />
      </div>
    </template>
  </ais-search-box>
</template>
